import React from 'react';

import Typography from 'components-new/typography/typography';

export type CrumbType = {
  name: string;
  onClick?: () => void;
};

const Crumb: React.FC<CrumbType> = ({ name, onClick }) => {
  if (onClick) {
    return (
      <button
        type="button"
        tabIndex={0}
        onClick={onClick}
        className="flex items-center"
      >
        <Typography
          as="span"
          variant="body-medium"
          className="capitalize self-center text-gray-400 hover:underline hover:text-gray-500 active:text-gray-700 focus:text-gray-700 focus:outline-none"
        >
          {name}
        </Typography>
      </button>
    );
  }
  return (
    <Typography
      as="span"
      variant="body-medium-bold"
      className="text-gray800 !font-semibold"
    >
      {name}
    </Typography>
  );
};

export default Crumb;
